import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { EASE } from "./motion";

const KEY = "po_intro_seen";

export const Intro = () => {
  const [show, setShow] = useState(() => !sessionStorage.getItem(KEY));

  useEffect(() => {
    if (!show) return;
    document.documentElement.classList.add("intro-lock");
    const t = setTimeout(() => {
      sessionStorage.setItem(KEY, "1");
      setShow(false);
    }, 2600);
    return () => {
      clearTimeout(t);
      document.documentElement.classList.remove("intro-lock");
    };
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="intro-overlay"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.9, ease: EASE } }}
          className="fixed inset-0 z-[200] flex items-center justify-center bg-[#FAF8F5]"
        >
          <div className="relative w-[70vw] max-w-[520px]">
            <motion.img
              src="/images/logo/mark-brand.png"
              alt=""
              initial={{ clipPath: "inset(0 100% 0 0)", opacity: 0.6 }}
              animate={{ clipPath: "inset(0 0% 0 0)", opacity: 1 }}
              transition={{ duration: 1.7, ease: [0.65, 0, 0.35, 1], delay: 0.15 }}
              className="w-full select-none"
              draggable="false"
            />
            <motion.p
              initial={{ opacity: 0, y: 6 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 1.5, duration: 0.7, ease: EASE }}
              className="mt-8 text-center font-mono text-[10px] uppercase tracking-[0.45em] text-[#66625A]"
            >
              PILATES ON. <span className="opacity-50">WORLD OFF.</span>
            </motion.p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
